"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigator = void 0;
/**
 * See Navigator_documentation.test.js to see how to consume this
 * @typedef BackT - the context for the back param (defaults to this)
 * @typedef RootT - the context for the root param (defaults to this)
 */
class Navigator {
    constructor(back, root) {
        // We've already strongly typed the value of this.back above, we've set it to
        // either 'BackT' or 'this' separately, however, that type is not compatilble with
        // 'BackT | this', because 'BackT !== BackT | this' and 'this !== BackT | this' (both
        // cases becase 'BackT !== this'), hence the need to cast to 'any' to make this work.
        // This doesn't weaken our types outside this class.
        this.back = (back || this);
        this.also = this.back;
        this.then = this.back;
        this.root = (root || this);
        this.finally = this.root;
        this.a = this;
        this.are = this;
        this.and = this;
        this.but = this;
        this.code = this;
        this.for = this;
        this.has = this;
        this.is = this;
        this.provide = this;
        this.theResponse = this;
        this.that = this;
        this.the = this;
        this.with = this;
        this.on = this;
        this.expect = this;
    }
}
exports.Navigator = Navigator;
